import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '../ExpantionPanel/ExpantionPanel';
import ExpansionPanelSummary from '../ExpantionPanel/ExpantionPanelSummary';
import ExpansionPanelDetails from '../ExpantionPanel/ExpantionPanelDetails';
import Typography from '@material-ui/core/Typography';
import QuantitySelector from '../QuantitySelector';
import { GolfCarate, ChevronDown, UpsideDownAlert } from '../Icons';

class GolferQtyExpantionPanel extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    onSelect: PropTypes.func
  };

  state = {
    showQtySelector: true
  }

  handlePanelChange = (event, expanded) => this.setState({
    showQtySelector: expanded
  })

  onSelect = qty => {
    this.props.onSelect(qty);
    this.setState({ showQtySelector: false })
  }

  render() {
    const { classes, golferCount, showAlert = false } = this.props;

    return (
      <div className={`${classes.border} ${showAlert ? classes.borderAlert : ''}`}>
        <ExpansionPanel elevation={0} expanded={this.state.showQtySelector || showAlert } onChange={this.handlePanelChange}>
          <ExpansionPanelSummary
            classes={{expanded: classes.expanded }}
            expandIcon={
              showAlert ? < UpsideDownAlert  className={classes.alertIcon}  /> :
              <ChevronDown   viewBox="0 0 24 13" className={classes.expandIcon} />
            }
            IconButtonProps={{ disableRipple: true }}
          >
            <GolfCarate viewBox="0 0 24 33" className={classes.teeIcon} />
            <div>
              {
                showAlert ?
                <Typography className={classes.alertText}>
                  Number of golfers is Required
                </Typography>
                : null
              }
              <Typography className={classes.header}>
                {golferCount === 0 ? `Choose Number Of Golfers` : `${golferCount} Golfers`}
              </Typography>

            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansion} >
            <QuantitySelector onSelect={this.onSelect} qty={golferCount} qtyList={[ 1, 2, 3, 4 ]} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

const styles = theme => ({
  border: {
    border: `1px solid #d5d8db`,
    width: 'auto',
    margin: '20px 0',
    marginBottom: '16px',
    borderRadius: '3px',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      width: '100%'
    }
  },
  alertText: {
    color: '#FF2552',
    marginLeft: '25px',
    fontSize: '10px'
  },
  borderAlert: {
    borderLeft: '3px solid #FF2552'
  },
  teeIcon: {
    height: '20px',
    marginTop: '3px'
  },
  alertIcon: {
    fontSize: '30px'
  },
  header: {
    fontSize: '14px',
    color: theme.grouponHeadingColor,
    marginTop: '5px',
    marginLeft: '25px',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      color: theme.palette.common.black
    }
  },
  expandIcon: {
    color: theme.palette.primary.main,
    fontSize: '20px'
  },
  expansion: {
    padding: 0,
    borderTop: '2px solid #EDEDED',
    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid #d5d8db'
    },
  },
  expanded: {
    margin: 0
  }
});

export default withStyles(styles, { withTheme: true })(GolferQtyExpantionPanel);


// WEBPACK FOOTER //
// ./src/components/GolferQtyExpantionPanel/index.js